import { render, staticRenderFns } from "./DateFormat.vue?vue&type=template&id=00bbf7ca&"
import script from "./DateFormat.vue?vue&type=script&lang=js&"
export * from "./DateFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DateFormat.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports